import { Children, useState } from 'react';
import { questions } from './data/questions';
import Game from './components/Game';
import Result from './components/Result';
import './App.scss';

// console.log(questions);

function App() {
  // стейт, который будет хранить шаг нашего вопроса
  const [step, setStep] = useState(0); // изначально шаг = 0 - это первый наш вопрос
  const currentQuestions = questions[step]; // сами объекты вопросов
  const [correct, setCorrect] = useState(0);

  const onClickVariant = (index) => {
    console.log(
      'step =>',
      step,
      'index =>',
      index,
      'questions.length =>',
      questions.length,
      'currentQuestions =>',
      currentQuestions
    );
    setStep(step + 1); // переходим на следующий шаг
    if (index === currentQuestions.correct) {
      // если вариант, который мы выбрали на текущем шаге совпадает на конкретном вопросе
      setCorrect(correct + 1);
      console.log('correct=>', correct);
    }
  };

  return (
    <div className="App">
      {step !== questions.length ? (
        <Game
          step={step}
          currentQuestions={currentQuestions}
          onClickVariant={onClickVariant}
          questions={questions}
        />
      ) : (
        <Result correct={correct} questions={questions} />
      )}
    </div>
  );
}
//  14 !==15

export default App;
